import {
  LayoutDashboard,
  Boxes,
  Layers3,
  Workflow,
  Warehouse,
  ShieldCheck,
  FileSpreadsheet,
  Brain,
} from "lucide-react";

export const topNav = [
  { key: "dashboard", label: "", path: "/", icon: LayoutDashboard },
  { key: "users", label: "Users", path: "/users", icon: Boxes },
  { key: "activity", label: "Production", path: "/activities", icon: Layers3 },
  {
    key: "salesandpurchases",
    label: "Sales & Purchases",
    path: "/sales-and-purchases",
    icon: FileSpreadsheet,
  },
  {
    key: "transaction",
    label: "Transactions",
    path: "/transactions",
    icon: ShieldCheck,
  },
  {
    key: "production",
    label: "Setup",
    path: "/production",
    icon: Workflow,
  },
  // { key: "inventory", label: "Inventory", path: "/inventory", icon: Warehouse },
  { key: "approval", label: "Approval", path: "/approval", icon: ShieldCheck },
  { key: "reports", label: "Reports", path: "/reports", icon: FileSpreadsheet },
  // { key: "ai", label: "AI Insights", path: "/ai-insights", icon: Brain },
];

export const subNavMap = {
  dashboard: [
    { label: "Overview", key: "overview" },
    { label: "Live Floor", key: "live-floor" },
    { label: "Targets", key: "targets" },
    { label: "Alerts", key: "alerts" },
  ],
  users: [
    { label: "User", key: "user" },
    { label: "Accounts", key: "accounts" },
    { label: "Customers", key: "customers" },
    { label: "Transporter", key: "transporter" },
    
  ],
  activity: [],
  salesandpurchases: [
    { label: "Sales Invoices", key: "sales-invoices" },
    { label: "Purchase Invoices", key: "purchase-invoices" },
    { label: "Challans", key: "challans" },
    { label: "Targets", key: "targets" },
    { label: "Incentives", key: "incentives" },
    { label: "Stock Transfer", key: "stocktransfer" },
  ],
  transaction: [
    { label: "Receipts", key: "receipts" },
    { label: "Payments", key: "payments" },
    { label: "Cashbook", key: "cashbook" },
    { label: "Bank Statement", key: "bank-statement" },
    { label: "Ledger", key: "ledger" },
  ],
  products: [
    { label: "Categories", key: "categories" },
    { label: "Sub Categories", key: "sub-categories" },
    { label: "Products", key: "products" },
    { label: "Bulk Upload", key: "bulk-upload" },
    { label: "Rate Matrix", key: "rate-matrix" },
  ],
  lots: [
    { label: "Create Lot", key: "create-lot" },
    { label: "Timeline", key: "timeline" },
    { label: "Split/Merge", key: "split-merge" },
    { label: "Labels", key: "labels" },
    { label: "Traceability", key: "traceability" },
  ],  // production: [
  //   "Accounts",
  //   "Category & SubCategories with Units",
  //   "Warehouse",
  //   "Product Sections",
  //   "Production Steps",
  //   "Products",
  //   "Incentives",
  //   "Price List",
  //   "Costing",
  // ],
  production: [
    { label: "Accounts", key: "accounts" },
    { label: "Unit", key: "units" },
    { label: "Category & SubCategories", key: "category-subcategory" },
    { label: "Warehouse", key: "warehouse" },
    { label: "Product Sections", key: "product-sections" },
    { label: "Production Steps", key: "production-steps" },
    { label: "Products", key: "products" },
    { label: "Incentives", key: "incentives" },
    { label: "Price List", key: "price-list" },
    { label: "Costing", key: "costing" },
  ],
  // inventory: [],
  approval: [
    { label: "Dispatch", key: "dispatch" },
    { label: "Settlement", key: "settlement" },
    { label: "Returns", key: "returns" },
    { label: "Agent Ledger", key: "agent-ledger" },
    { label: "Commission", key: "commission" },
  ],
  reports: [
    { label: "Production", key: "production" },
    { label: "Loss", key: "loss" },
    { label: "Stock", key: "stock" },
    { label: "Compelete Stock", key: "compeletestock" },
    { label: "Wastage Report", key: "wastagereport" },
    { label: "Worker Report", key: "worker" },
    { label: "Margins", key: "margins" },
    { label: "Exports", key: "exports" },
    { label: "Raw", key: "raw" },
    { label: "WIP", key: "wip" },
    { label: "Finished", key: "finished" },
    { label: "Approval Stock", key: "approval-stock" },
    { label: "Movements", key: "movements" },
    { label: "Dead Stock", key: "dead-stock" },
  ],
  // ai: [
  //   "Predictions",
  //   "Demand Forecast",
  //   "Loss Alerts",
  //   "Rate Suggestion",
  //   "Anomalies",
  // ],
};

// export function getSectionHref(topKey, section) {
//   const parent = topNav.find((item) => item.key === topKey);
//   if (!parent) return "/";
//   if (!section) return parent.path;
//   return `${parent.path}?view=${encodeURIComponent(section)}`;
// }
export function getSectionHref(topKey, sectionKey) {
  const parent = topNav.find((item) => item.key === topKey);
  if (!parent) return "/";
  if (!sectionKey) return parent.path;

  return `${parent.path}?view=${sectionKey}`;
}
// export const quickActionGroups = topNav.map((parent) => ({
//   key: parent.key,
//   label: parent.label,
//   path: parent.path,
//   sections: (subNavMap[parent.key] || []).map((section) => ({
//     label: section,
//     path: getSectionHref(parent.key, section),
//   })),
// }));
export const quickActionGroups = topNav.map((parent) => ({
  key: parent.key,
  label: parent.label,
  path: parent.path,
  sections: (subNavMap[parent.key] || []).map((section) => ({
    label: section.label,
    path: getSectionHref(parent.key, section.key),
  })),
}));
